// assets/cart-optimization.js
(function() {
  // Utility to update cart UI
  function updateCartUI(cart) {
    // Update cart count badge
    var countEls = document.querySelectorAll('.cart-count, .header-cart-count');
    countEls.forEach(el => el.textContent = cart.item_count);

    // Update cart subtotal
    var subtotalEls = document.querySelectorAll('.cart-subtotal, .cart__subtotal .money');
    subtotalEls.forEach(el => {
      if (window.Shopify && Shopify.formatMoney) {
        el.textContent = Shopify.formatMoney(cart.items_subtotal_price, el.dataset.moneyFormat || '') ;
      } else {
        el.textContent = (cart.items_subtotal_price/100).toFixed(2);
      }
    });
  }

  // Handle quantity changes and removals
  function handleCartAction(event) {
    var btn = event.target.closest('[data-cart-action]');
    if (!btn) return;
    event.preventDefault();

    var action = btn.getAttribute('data-cart-action');
    var line = parseInt(btn.getAttribute('data-line'), 10);
    var qtyInput = document.querySelector('[data-line-input="' + line + '"]');
    var newQty = action === 'remove' ? 0 : (action === 'decrease' ? (qtyInput.value - 1) : (qtyInput.value*1 + 1));

    // Optimistic update
    if (action === 'remove') {
      var itemEl = document.querySelector('[data-line-item="' + line + '"]');
      if (itemEl) itemEl.remove();
    } else {
      qtyInput.value = newQty;
      // Optionally update line price immediately if markup present
      var priceEl = document.querySelector('[data-line-price="' + line + '"]');
      if (priceEl) {
        // price update will be handled after fetch
      }
    }

    // Send AJAX update
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ line: line, quantity: newQty })
    })
    .then(res => res.json())
    .then(cart => {
      updateCartUI(cart);
    })
    .catch(err => {
      console.error('Cart update failed:', err);
      window.location.reload();
    });
  }

  document.addEventListener('click', handleCartAction);
})();


// Smooth fade enhancements for price changes
function animatePrice(el, newText) {
  el.classList.add('price-animate', 'price-fade-out');
  setTimeout(() => {
    el.textContent = newText;
    el.classList.remove('price-fade-out');
    setTimeout(() => el.classList.remove('price-animate'), 250);
  }, 250);
}

function observePriceMutations() {
  const priceEls = document.querySelectorAll('.cart-item__price, .cart-subtotal__price, .bundle-discount__amount');
  priceEls.forEach(el => {
    const mo = new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.type === 'childList' || m.type === 'characterData') {
          const updated = el.textContent;
          mo.disconnect();
          el.textContent = m.target.data || updated;
          animatePrice(el, updated);
          setTimeout(() => mo.observe(el, {
            characterData: true,
            childList: true,
            subtree: true
          }), 0);
        }
      });
    });
    mo.observe(el, {
      characterData: true,
      childList: true,
      subtree: true
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  observePriceMutations();
});
